export const link = (theme) => ({
    /* Styles applied to the root element. */
    link: {
        color: theme.palette.text.primary,
        display: "flex",
        alignItems: "center",
        margin: 0,
        textDecoration: "none",
        "&:hover": {
            cursor: "pointer",
            color: theme.palette.text.primary,
        },
    },
    label: {
        textTransform: "capitalize",
        whiteSpace: "nowrap",
        // border: `3px solid ${theme.customPalette.darkishPurple}`,
        paddingBottom: 2,
        marginRight: 4,
        fontFamily: "Spezia",
    },
    icon: {
        width: 21,
        height: 21,
    },
});

export const linkButton = (theme) => ({
    /* Styles applied to the root element. */
    root: {
        display: "flex",
        margin: 0,
        "&:hover": {
            cursor: "pointer",
        },
    },
    label: {
        textTransform: "uppercase",
        // color: theme.customPalette.secondaryYellowYButtons,
        marginRight: 4,
    },
    icon: {
        width: 21,
        height: 21,
    },
});
